export default "__VITE_PUBLIC_ASSET__0aad603c__"